module.exports = __webpack_public_path__ + "img/logo-isoc-tr.5d9362a5.png";